export const getFilledPercentage = (total: number, value: number) => {
    if (total === 0) return "0%";

    const rawPercentage = (value * 100) / total;
    const roundedPercentage = Math.round(rawPercentage);

    return `${roundedPercentage}%`;
};
